var Alabama = "阿拉巴马州";
var Alaska = "阿拉斯加州";
var Arizona = "亚利桑那州";
var Arkansas = "阿肯色州";
var California = "加利福尼亚州";
var Colorado = "科罗拉多州";
var Connecticut = "康涅狄格州";
var Delaware = "特拉华州";
var Florida = "佛罗里达州";
var Georgia = "佐治亚州";
var Hawaii = "夏威夷州";
var Idaho = "爱达荷州";
var Illinois = "伊利诺斯州";
var Indiana = "印地安那州";
var Iowa = "爱荷华州";
var Kansas = "堪萨斯州";
var Kentucky = "肯塔基州";
var Louisiana = "路易斯安那州";
var Maine = "缅因州";
var Maryland = "马里兰州";
var Massachusetts = "马萨诸塞州";
var Michigan = "密歇根州";
var Minnesota = "明尼苏达州";
var Mississippi = "密西西比州";
var Missouri = "密苏里州";
var Montana = "蒙大纳州";
var Nebraska = "内布拉斯加州";
var Nevada = "内华达州";
var Ohio = "俄亥俄";
var Oklahoma = "俄克拉荷马州";
var Oregon = "俄勒冈";
var Pennsylvania = "宾夕法尼亚州";
var Tennessee = "田纳西州";
var Texas = "德克萨斯州";
var Utah = "犹他州";
var Vermont = "佛蒙特州";
var Virginia = "北部";
var Washington = "华盛顿州";
var Wisconsin = "威斯康星州";
var Wyoming = "怀俄明州";
var USStates = {
	Alabama: Alabama,
	Alaska: Alaska,
	Arizona: Arizona,
	Arkansas: Arkansas,
	California: California,
	Colorado: Colorado,
	Connecticut: Connecticut,
	Delaware: Delaware,
	"District of Columbia (DC)": "哥伦比亚特区 (DC)",
	Florida: Florida,
	Georgia: Georgia,
	Hawaii: Hawaii,
	Idaho: Idaho,
	Illinois: Illinois,
	Indiana: Indiana,
	Iowa: Iowa,
	Kansas: Kansas,
	Kentucky: Kentucky,
	Louisiana: Louisiana,
	Maine: Maine,
	Maryland: Maryland,
	Massachusetts: Massachusetts,
	Michigan: Michigan,
	Minnesota: Minnesota,
	Mississippi: Mississippi,
	Missouri: Missouri,
	Montana: Montana,
	Nebraska: Nebraska,
	Nevada: Nevada,
	"New Hampshire": "新罕布什尔州",
	"New Jersey": "新泽西州",
	"New Mexico": "新墨西哥州",
	"New York": "纽约",
	"North Carolina": "北卡罗来纳州",
	"North Dakota": "北达科他州",
	Ohio: Ohio,
	Oklahoma: Oklahoma,
	Oregon: Oregon,
	Pennsylvania: Pennsylvania,
	"Rhode Island": "罗得岛州",
	"South Carolina": "南卡罗来纳州",
	"South Dakota": "南达科他州",
	Tennessee: Tennessee,
	Texas: Texas,
	Utah: Utah,
	Vermont: Vermont,
	Virginia: Virginia,
	Washington: Washington,
	"West Virginia": "西弗吉尼亚州",
	Wisconsin: Wisconsin,
	Wyoming: Wyoming
};

export { Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, Ohio, Oklahoma, Oregon, Pennsylvania, Tennessee, Texas, Utah, Vermont, Virginia, Washington, Wisconsin, Wyoming, USStates as default };
